module.exports = __webpack_public_path__ + "398eb827bbfa70b8fc843bb83f3ac3a1.png";